import { useHistory } from "react-router-dom";

const useCustomNavigate = () => {
  const history = useHistory();

  const navigateTo = (path) => {
    history.push(path);
  };
  const navigateToWithState = (path, state) => {
    history.push(path, state);
  };
  const navigateToReplace = (path) => {
    history.replace(path);
  };
  const goBack = () => {
    history.goBack();
  };
  return { navigateTo, navigateToWithState, navigateToReplace, goBack };
};
export default useCustomNavigate;
